<template>
  <div style="height: calc(100vh - 135px);overflow: auto;padding-right:8px">
    <div class="page_header" style="">
      <span class="page_title" style="flex: 1;">{{ $t('statistics.电机运行分析') }}</span>
      <quickQuery :isDownload="true" :downloading="loading" @handleQuery="handleQuery" @quickQuery="quickQuery" @download="onExport"
        style="text-align: right" />
    </div>
    <div><el-divider></el-divider></div>
    <!-- <div id="rangeChart" style="height:300px;width:100%;"></div> -->
    <div v-loading="loading">
      <div id="temptChart" style="height:300px;width:100%;"></div>
      <div id="speedChart" style="height:300px;width:100%;"></div>
    </div>
    <div class="page_container">
      <el-table :size="size" border :data="list" v-loading="loading">
        <!-- <el-table-column align="center" prop="" label="序号" min-width=""></el-table-column> -->
        <el-table-column align="center" prop="CarNo" :label="$t('statistics.车辆')" min-width=""></el-table-column>
        <el-table-column align="center" prop="TheDate" :label="$t('statistics.车辆运行时间')" min-width=""></el-table-column>
        <el-table-column align="center" prop="MinTemp" :label="$t('statistics.电机最低温度(℃)')"
          min-width=""></el-table-column>
        <el-table-column align="center" prop="MaxTemp" :label="$t('statistics.电机最高温度(℃)')"
          min-width=""></el-table-column>
        <el-table-column align="center" prop="MinSpeed" :label="$t('statistics.电机最低转速(r/min)')"
          min-width=""></el-table-column>
        <el-table-column align="center" prop="MaxSpeed" :label="$t('statistics.电机最高转速(r/min)')"
          min-width=""></el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div>
      <kl-pagination :total="total" @current-change="pageChange" :pageSize="pageSize"
        :currentPage="currentPage"></kl-pagination>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
// import * as echarts from "echarts";
import quickQuery from '../components/generalOrQuickQuery.vue'
import * as XLSX from 'xlsx'
export default {
  name: "motorStatistics",
  components: { quickQuery },
  data() {
    return {
      pageSize: 10,
      currentPage: 1,
      total: 0,
      showLabel: false,
      isReverse: false,
      temptChart: undefined,
      speedChart: undefined,
      rangeChart: undefined,
      dataList: [],
      loading: false,
    }
  },
  computed: {
    list() {
      if (this.dataList != null && this.dataList.length > 0) {
        return this.dataList.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)
      }
      return [];
    },
    ...mapState({
      //   opened: state => state.app.sidebar.opened,
      selectedVehicles: (state) => state.app.vehicles.selectedVehicles,
      size: (state) => state.app.size,
    }),
  },
  watch: {},
  mounted() {


    this.initTemptChart();
    this.initSpeedChart();
  },
  activated() {
    this.setResize();
    window.addEventListener('resize', this.setResize)
  },
  destroyed() {
    window.removeEventListener('resize', this.setResize)
  },
  deactivated() {
    window.removeEventListener('resize', this.setResize)
  },
  methods: {
    // 分页
    pageChange(page) {
      this.currentPage = page;
    },
    onExport() {
      // 接口已返回全部数据，直接导出 dataList
      if (!this.dataList || this.dataList.length === 0) {
        this.$message.warning(this.$t('statistics.no_data_export'));
        return;
      }
      this.exportToExcel(this.dataList);
      this.$message.success(this.$t('statistics.export_success'));
    },
    exportToExcel(list) {
      const header = [
        this.$t('statistics.车辆'),
        this.$t('statistics.车辆运行时间'),
        this.$t('statistics.电机最低温度(℃)'),
        this.$t('statistics.电机最高温度(℃)'),
        this.$t('statistics.电机最低转速(r/min)'),
        this.$t('statistics.电机最高转速(r/min)')
      ];
      const rows = list.map(item => [
        item.CarNo || '',
        item.TheDate || '',
        item.MinTemp != null ? item.MinTemp : '',
        item.MaxTemp != null ? item.MaxTemp : '',
        item.MinSpeed != null ? item.MinSpeed : '',
        item.MaxSpeed != null ? item.MaxSpeed : ''
      ]);
      const aoa = [header, ...rows];
      const ws = XLSX.utils.aoa_to_sheet(aoa);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, this.$t('statistics.电机运行分析'));
      const fileName = this.$t('statistics.电机运行分析') +
        this.moment(new Date()).format('YYYY-MM-DD') + '.xlsx';
      XLSX.writeFile(wb, fileName);
    },
    setResize() {
      this.temptChart.resize();
      this.speedChart.resize();
    },
    handleQuery(val) {
      console.log(val);

      if (this.selectedVehicles.length == 0) {
        this.$message.warning(this.$t("vehicletrack.selectvehicle"));
        return;
      }
      if (this.selectedVehicles.length > 1) {
        this.$message.warning(this.$t("vehicletrack.selectmorevehicle"));
        return;
      }
      if (val.beginDate == "") {
        this.$message.error(this.$t('time.selectQueryTime'));
        return;
      }
      this.getData(val);

    },
    quickQuery(val) {
      if (this.selectedVehicles.length == 0) {
        this.$message.warning(this.$t("vehicletrack.selectvehicle"));
        return;
      }
      if (this.selectedVehicles.length > 1) {
        this.$message.warning(this.$t("vehicletrack.selectmorevehicle"));
        return;
      }
      if (val.beginDate == "") {
        this.$message.error(this.$t('time.selectQueryTime'));
        return;
      }
      this.getData(val);
    },
    getData(val) {
      this.loading = true;
      var vin = this.selectedVehicles[0].nodeValue
      this.$api.queryMotorInfo({
        "VehicleID": vin + '',// "140109", 
        "BeginTime": val.beginDate,//"2025-09-05",
        "EndTime": val.endDate,//"2025-09-14"
      })
        .then((res) => {
          if (res.code == 200) {
            this.loading = false;
            this.dataList = res.data;
            this.total = res.data.length;

            let x_data = [];
            let yTemp_data = [];
            let ySpeed_data = [];
            this.dataList.forEach(element => {
              x_data.push(element.TheDate);
              yTemp_data.push([
                element.MinTemp,
                element.MaxTemp,
                element.MinTemp,
                element.MaxTemp
              ]);
              ySpeed_data.push([
                element.MinSpeed,
                element.MaxSpeed,
                element.MinSpeed,
                element.MaxSpeed
              ]);

            });
            var option_1 = {
              xAxis: {
                type: 'category',
                data: x_data,
              },
              series: [
                {
                  data: yTemp_data,
                }
              ]
            };
            var option_2 = {
              xAxis: {
                type: 'category',
                data: x_data,
              },
              series: [
                {
                  data: ySpeed_data,
                }
              ]
            };
            this.temptChart.setOption(option_1);
            this.speedChart.setOption(option_2);

          }
        })
        .catch((e) => {
          this.loading = false;
        })
    },
    getDefaultOption(title, formatter, yAxis_name, series_name, yMin) {
      return {
        title: {
          text: title,
          left: 'left'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          },
          formatter: formatter
        },
        xAxis: {
          type: 'category',
          data: [],
          // boundaryGap: false,
          axisLine: { onZero: yMin ? false : true },
          splitLine: { show: true },

        },
        yAxis: {
          name: yAxis_name,
          type: 'value',
          scale: true,
          min: function (value) {

            if (yMin) return yMin
            else return Math.floor(value.min * 0.9);
          },
          max: function (value) {
            return Math.ceil(value.max * 1.1);
          },
          splitArea: {
            show: true
          }
        },
        series: [
          {
            name: series_name,
            type: 'candlestick', // K线图类型
            data: [],
            barWidth: 15,
            itemStyle: {
              color: '#2A7AFF', // 上涨颜色
              color0: '#2A7AFF', // 下跌颜色
              borderColor: '#2A7AFF',
              borderColor0: '#2A7AFF'
            },
            large: true,
            tooltip: {
              valueFormatter: function (value) {
                return value + '%';
              }
            }
          },
          {
            name: series_name,
            type: 'candlestick', // K线图类型
            data: [],
            barWidth: 15,
            itemStyle: {
              color: '#2A7AFF', // 上涨颜色
              color0: '#2A7AFF', // 下跌颜色
              borderColor: '#2A7AFF',
              borderColor0: '#2A7AFF'
            },
            large: true,
            tooltip: {
              valueFormatter: function (value) {
                return value + '%';
              }
            }
          }
        ]
      };
    },
    initSpeedChart() {
      //电机转速
      this.speedChart = echarts.init(document.getElementById('speedChart'));

      const option = this.getDefaultOption(this.$t('statistics.电机转速'), function (params) {
        const param = params[0];

        return `
        <div style="font-weight: bold;">${param.name}</div>
        <div>电机最低转速: ${param.data[1]} r/min</div>
        <div>电机最高转速: ${param.data[2]} r/min</div>
      
      `;
      }, this.$t('statistics.转速') + '(r/min)', this.$t('statistics.转速'));

      // 使用配置项渲染图表
      this.speedChart.setOption(option);

      // // 监听窗口 resize 事件，自适应图表大小
      // window.addEventListener('resize', () => {
      //     this.speedChart.resize();
      // });
    },
    initTemptChart() {
      //电机温度
      this.temptChart = echarts.init(document.getElementById('temptChart'));

      const option = this.getDefaultOption(this.$t('statistics.电机温度'), function (params) {
        const param = params[0];

        return `
        <div style="font-weight: bold;">${param.name}</div>
        <div>电机最低温度: ${param.data[1]} ℃</div>
        <div>电机最高温度: ${param.data[2]} ℃</div>
      
      `;
      }, this.$t('statistics.温度') + '(℃)', this.$t('statistics.温度'), -20);

      // 使用配置项渲染图表
      this.temptChart.setOption(option);

      // // 监听窗口 resize 事件，自适应图表大小
      // window.addEventListener('resize', () => {
      //     this.temptChart.resize();
      // });
    },
  },
}
</script>